import { CalendarService } from '../../api';
import { useItems } from './useItems';

const fetcher = ({ startDate, endDate }: { startDate: string; endDate: string }) =>
  CalendarService.getCalendarNotes(startDate, endDate);

type useNotesProps = { startDate: string; endDate: string };

export const useNotes = ({ startDate, endDate }: useNotesProps) => {
  const { items, error, isLoading, deleteItem, addItems, updateItem, reFetch } = useItems({
    startDate,
    endDate,
    opId: 'getCalendarNotes',
    fetcher,
    refreshInterval: 60000,
  });

  return {
    items: items || {},
    isLoading,
    isError: error,
    deleteItem,
    reFetch,
    addItems,
    updateItem,
  };
};
